import React from 'react';

const IconSend: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    width='16'
    viewBox='0 0 24 24'
    focusable='false'
    role='presentation'
    fill='none'
    {...props}
    className={`icon icon-send${props.className ? ' ' + props.className : ''}`}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M2.01 21L23 12 2.01 3 2 10l15 2-15 2z'></path>
  </svg>
);
export default IconSend;
